/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module TechSupportListPageModule
 */

import {
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import {
    TechSupportGenerationService,
} from 'ng/modules/support/services/tech-support-generation.service';

import {
    AviDropdownButtonPosition,
    IAviDropdownButtonAction,
} from 'ng/shared/components/avi-dropdown-button';

import './tech-support-page-card.component.less';

import { Subscription } from 'rxjs';
import * as l10n from './tech-support-page-card.l10n';
import { ITechSupport } from '../../../../../generated-types/rest_dependents';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Card component for Tech Support to display current progress.
 * @author Anjali Tanpure, Shahab Hashmi, Dhanashree Tilak
 */
@Component({
    selector: 'tech-support-page-card',
    templateUrl: './tech-support-page-card.component.html',
})
export class TechSupportPageCardComponent implements OnInit, OnDestroy {
    /**
     * List of actions for each package.
     */
    public packageActions: IAviDropdownButtonAction[];

    /**
     * Position of actions dropdown menu.
     */
    public buttonDropdownPosition = AviDropdownButtonPosition.BOTTOM_LEFT;

    /**
     * Selected Tech Support Package
     */
    public selectedPackage: ITechSupport;

    public openProgressWizard = false;

    public readonly l10nKeys = l10nKeys;

    /**
     * List of packages with generation in progress.
     */
    public packagesInProgress: ITechSupport[] = [];

    private packagesSubscription: Subscription;

    constructor(
        private readonly l10nService: L10nService,
        public readonly techSupportGenerationService: TechSupportGenerationService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.packagesSubscription = this.techSupportGenerationService.packagesInProgress$.subscribe(packages => {
            this.packagesInProgress = packages;
        });

        const { l10nService } = this;

        this.packageActions = [
            {
                label: l10nService.getMessage(l10nKeys.viewProgressLabel),
                onClick: (pkg: ITechSupport) => {
                    this.openProgressWizard = true;
                    this.selectedPackage = pkg;
                },
            },
        ];
    }

    /** @override */
    public ngOnDestroy(): void {
        if (this.packagesSubscription) {
            this.packagesSubscription.unsubscribe();
        }
    }

    /**
     * Update state when the wizard is closed.
     */
    public onClose(): void {
        this.openProgressWizard = false;
    }
}
